<template>
  <AdultPinCheck :success-fn="success">
    <div slot="header">
      <h3 class="hd-title">성인인증</h3>
      <button class="component-close" @click.prevent="close()">
        <CloseIcon/>
      </button>
    </div>
    <div slot="title">
      <strong class="ch-adult-title">성인 비밀번호 설정</strong>
      <p class="ch-adult-text01">Wavve TV 앱에서 사용 중인<br>성인 비밀번호 4자리를 입력해주세요.</p>
    </div>
    <template v-slot:bottom_buttons="scopedValue">
      <BottomButtons :scopedValue="scopedValue"></BottomButtons>
    </template>
  </AdultPinCheck>
</template>
<script>
import AdultPinCheck from '@/views/adult/AdultPinCheck.vue'
import BottomButtons from '@/views/adult/AdultCheckBottomButtons.vue'
import CloseIcon from '@/assets/svg/common/ic-gnb-close-w.svg'
import { get } from 'lodash'
export default {
  name: 'AdultPinCheckForSetPinCode',
  components: {
    AdultPinCheck,
    BottomButtons,
    CloseIcon
  },
  data () {
    return {
      referer: get(this.$route, 'query.referer', '')
    }
  },
  methods: {
    close () {
      const target = this.referer === '' ? '/' : this.referer
      this.$router.replace(target)
    },
    success () {
      this.$router.replace(`/adultverify/pin_adult/complete?referer=${this.referer}`)
    }
  }
}
</script>
